import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {createSelector} from 'reselect';
import queryString from 'query-string';
import update from 'react-addons-update';

import {request} from '../../containers/actions';
import Tree from '../tree';
import {removeItemSelection} from '../tree/actions';
import {showMessage, hideMessage} from '../../paginator/actions';
import PaginatedContainer from '../../paginator/paginated_container';
import studentsFiltersSelectorGenerator from '../students/filters';
import examinationsFiltersSelectorGenerator from '../examinations/filters';
import { ServerDate } from '../../containers/ServerDate';


export default class Registrations extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
        buttonActions: PropTypes.array,
    }

    static defaultProps = {
        readonly: false,
        selectable: false,
        actions: [],
        buttonActions: [],
    }

    state = {
        registrations: {},
        add: {},
        remove: [],
    };

    style = {items: {itemsList: {width: 'auto', overflowX: 'auto'}}}

    listFieldsSelector = createSelector(
        [
            () => this.state.registrations,
            () => this.props.store.getIn(['examinationsTreeFilter', 'selected_data']),
            () => this.props.store.get('selected'),
            () => this.props.store.getIn(['paginator', 'data']),
        ],
        (registrations, selectedExaminations, selectedStudents, allStudents) => {
            return[
            {field: 'id', label: window.gettext('ID')},
            {field: item => `${item.firstname} ${item.lastname}`, label: window.gettext('Name')},
            {field: item => item.grade ? item.grade.title : '-', label: window.gettext('Grade')},
            {field: item => item.school ? item.school.name : '-', label: window.gettext('School')},
            {field: item => item.city ? item.city.name : '-' , label: window.gettext('City')},
            {field: item => item.city ? item.city.region_display : '-', label: window.gettext('Region')},
            {field: 'national_id', label: window.gettext('National ID')},
            ...selectedExaminations.map(
                (examination, id) => {
                    return ({
                    field: item => this.state.registrations[item.id] && this.state.registrations[item.id][id]
                        ? (examination.online===null?(this.state.registrations[item.id][id].online?window.gettext('Online'):window.gettext('Paper Based')):'\u2713')
                        : '\u2715',
                    label: 
                    <div>
                    {examination.label}
                    {
                        examination.online==null?(
                            [
                                this.createAzmunRegistrationCheckbox(selectedStudents,id,allStudents,examination,true)
                                ,
                                this.createAzmunRegistrationCheckbox(selectedStudents,id,allStudents,examination,false)
                            ]
                        )
                        :this.createAzmunRegistrationCheckbox(selectedStudents,id,allStudents,examination)
                    }
                    </div>,
                })}
            ).toArray(),
        ]},
    )

    createAzmunRegistrationCheckbox(selectedStudents,id,allStudents,examination,registerForOnline=null)
    {
        return <label style={{cursor: 'pointer', whiteSpace: 'pre-wrap'}} htmlFor={id+'-'+registerForOnline}>
        <input
            ref={'examination-checkbox-' + id}
            key={id+'-'+registerForOnline}
            id={id+'-'+registerForOnline}
            type='checkbox'
            checked={(selectedStudents.size ? selectedStudents : allStudents).every(
                student => this.state.registrations[student.get('id')] 
                    && 
                    this.state.registrations[student.get('id')][id]
                    &&
                    (
                        registerForOnline===null
                        ||
                        this.state.registrations[student.get('id')][id].online === registerForOnline
                    )
            )}
            onChange={async ({target: {checked}}) => {
                this.doCheckForSelectedExamination(checked,selectedStudents,id,allStudents,examination,registerForOnline==null?examination.online:registerForOnline)
                
            }}
        />
        {registerForOnline==null
            ?''
            :(
                registerForOnline
                    ?window.gettext('Online')
                    :window.gettext('Paper Based')
            )}

    </label>
    }

    

    async doCheckForSelectedExamination(checked,selectedStudents,id,allStudents,examination,forOnline=true)
    {debugger;
        if (checked) {
            const students = (selectedStudents.size ? selectedStudents : allStudents).filter(
                student => !this.state.registrations[student.get('id')] || !this.state.registrations[student.get('id')][id],
            );
            const apiUrl = examination.type === 2 ? "/registerEssayStudentExam/" : "/registration/";
            const apiBody = examination.type === 2 ? {
                students: students.map(student => student.get('id')).toArray().join(','),
                examId: id,
                online: forOnline
            } : students.map(student => ({
                student: { id: student.get('id') },
                examination: { id },
                online: forOnline
            })).toArray();
            
            if (students.size === 0)
                return;
            const response = await this.context.store.dispatch(request({
                path: apiUrl, 
                body: apiBody,
                method: 'POST',
            },null,null,null,()=>{
                alert("خطا در زمان ثبت نام. دانش آموز تکراری انتخاب شده است. لطفا دانش آموزان انتخاب شده را بررسی و مجدد انتخاب کنید.")
            }));
            if(examination.type === 2 ){  
                const messageId = ServerDate().getTime();
                this.context.store.dispatch(showMessage({
                    message: window.interpolate(
                        window.gettext('%(count)s students registered in ' +
                            'examination %(examination)s.'),
                        {
                            count: response.count.persian(),
                            examination:examination.label,
                        },
                        true,
                    ),
                    id: messageId,
                }, this.props.store.getIn(['paginator', 'elementId'])));
                setTimeout(() => this.context.store.dispatch(hideMessage({
                    id: messageId,
                }, this.props.store.getIn(['paginator', 'elementId']))), 3000);
                await this.fetch();
            }
            else{
                const registrations = _.cloneDeep(this.state.registrations);
                _.forEach(
                    response,
                    registration => registrations[registration.student.id][registration.examination.id] = registration
                );
                this.setState({registrations});
                const messageId = ServerDate().getTime();
                this.context.store.dispatch(showMessage({
                    message: window.interpolate(
                        window.gettext('%(count)s students registered in ' +
                            'examination %(examination)s.'),
                        {
                            count: response.length.persian(),
                            examination:examination.label,
                        },
                        true,
                    ),
                    id: messageId,
                }, this.props.store.getIn(['paginator', 'elementId'])));
                setTimeout(() => this.context.store.dispatch(hideMessage({
                    id: messageId,
                }, this.props.store.getIn(['paginator', 'elementId']))), 3000);
            }
            
        }
        else {
            const students = (selectedStudents.size ? selectedStudents : allStudents).filter(
                student => this.state.registrations[student.get('id')] && this.state.registrations[student.get('id')][id],
            );
            if (students.size === 0)
                return;
            await this.context.store.dispatch(request({
                path: '/registration/?' + queryString.stringify({
                    student: students.map(student => student.get('id')).toArray().join(','),
                    examination: id,
                }),
                method: 'DELETE',
            }));
            this.setState(update(this.state, {
                registrations: students.toMap().mapKeys((__, student) => student.get('id')).map(
                    () => ({[id]: {$apply: () => undefined}}),
                ).toJS(),
            }));
            const messageId = ServerDate().getTime();
            this.context.store.dispatch(showMessage({
                message: window.interpolate(
                    window.gettext('%(count)s students removed from ' +
                        'examination %(examination)s.'),
                    {
                        count: students.size.persian(),
                        examination:examination.label,
                    },
                    true,
                ),
                id: messageId,
            }, this.props.store.getIn(['paginator', 'elementId'])));
            setTimeout(() => this.context.store.dispatch(hideMessage({
                id: messageId,
            }, this.props.store.getIn(['paginator', 'elementId']))), 3000);
        }
    }

    studentsFiltersSelector = studentsFiltersSelectorGenerator.bind(this)()
    examinationsFiltersSelector = examinationsFiltersSelectorGenerator.bind(this)('__')

    filtersSelector = createSelector.bind(this)(
        [
            store => this.studentsFiltersSelector(store),
            store => this.examinationsFiltersSelector(store.get('examinationFilters')),
            () => this.props.store.getIn(['examinationsTreeFilter']),
        ],
        (studentsFilters, examinationsFilters) => [
            ...studentsFilters,
            ...examinationsFilters,
            {
                label: window.gettext('Examination'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('examinationsTreeFilter')}
                        readonly
                        header
                        resource='examination'
                        itemLabel={examination => _.map(
                            examination.grades,
                            grade => grade.title,
                        ).join(window.gettext(',') + ' ') + ' - ' + examination.title}
                        filter={{
                            grades: this.props.store.getIn(['examinationFilters', 'gradesTreeFilter', 'selected']).keySeq().join(',') || -1,
                            'examination_type':
                            this.props.store.getIn(['examinationFilters', 'typesTreeFilter', 'selected']).keySeq().join(','),
                            step: this.props.store.getIn(['examinationFilters', 'stepsTreeFilter', 'selected']).keySeq().join(','),
                            online: this.props.store.getIn(['examinationFilters', 'onlineTreeFilter', 'selected']).keySeq().join(','),
                            restricted: this.props.store.getIn(['examinationFilters', 'restrictedTreeFilter', 'selected']).keySeq().join(','),
                            registered: this.props.store.getIn(['examinationFilters', 'registeredTreeFilter', 'selected']).keySeq().join(','),
                            'date__range': this.props.store.getIn(['examinationFilters', 'yearsTreeFilter', 'selected']).size
                                ? Number(this.props.store.getIn([
                                    'examinationFilters',
                                    'yearsTreeFilter',
                                    'selected',
                                ]).keySeq().sort().first().split(':')[0] / 1000 - 2678400) + ',' + Number(this.props.store.getIn([
                                    'examinationFilters',
                                    'yearsTreeFilter',
                                    'selected',
                                ]).keySeq().sort().last().split(':')[1] / 1000 - 2678400)
                                : '-1',
                            'books__isnull': 'True',
                        }}
                        label={window.gettext('Examination')}
                    />
                </div>,
                selected: this.props.store.getIn(['examinationsTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'examination',
                    this.props.store.getIn(['examinationsTreeFilter', 'elementId']),
                )),
            },
        ],
    )

    sorts = [
        {name: 'id', label: window.gettext('ID'), reversed: true},
        {name: 'national_id', label: window.gettext('national id')},
        {name: 'firstname', label: window.gettext('firstname')},
        {name: 'lastname', label: window.gettext('lastname')},
        {name: 'grade', label: window.gettext('Grade')},
        {name: 'school', label: window.gettext('School')},
        {name: 'city', label: window.gettext('City')},
        {name: 'region', label: window.gettext('Region')},
    ]

    componentDidMount() {
        if (
            this.props.store.getIn(['examinationsTreeFilter', 'selected']).size > 0 &&
            this.props.store.getIn(['paginator', 'data']).size > 0
        )
            this.fetch.bind(this)();
            this.createAzmunRegistrationCheckbox = this.createAzmunRegistrationCheckbox.bind(this);
            this.doCheckForSelectedExamination = this.doCheckForSelectedExamination.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.store.getIn(['examinationsTreeFilter', 'selected']).size > 0 &&
            this.props.store.getIn(['paginator', 'data']).size > 0 && (
                prevProps.store.getIn(['examinationsTreeFilter', 'selected']) !== this.props.store.getIn(['examinationsTreeFilter', 'selected']) ||
                prevProps.store.getIn(['paginator', 'data']) !== this.props.store.getIn(['paginator', 'data'])
            )
        )
            this.fetch.bind(this)();
        if (
            prevProps.store.getIn(['examinationsTreeFilter', 'selected']) !== this.props.store.getIn(['examinationsTreeFilter', 'selected']) ||
            prevProps.store.getIn(['paginator', 'data']) !== this.props.store.getIn(['paginator', 'data']) ||
            prevProps.store.get('selected') !== this.props.store.get('selected') ||
            !_.isEqual(prevState.registrations, this.state.registrations)
        )
            this.props.store.getIn(['examinationsTreeFilter', 'selected']).forEach((examination, id) => {
                const states = (this.props.store.get('selected').size ? this.props.store.get('selected') : this.props.store.getIn(['paginator', 'data'])).map(
                    student => Boolean(
                        this.state.registrations[student.get('id')] &&
                        this.state.registrations[student.get('id')][id],
                    ),
                );
                this.refs['examination-checkbox-' + id].indeterminate = states.some(_.identity) && !states.every(_.identity);
            });
    }

    async fetch() {
        const students = this.props.store.getIn(['paginator', 'data']);
        const examinations = this.props.store.getIn(['examinationsTreeFilter', 'selected']);
        if (
            students !== this.props.store.getIn(['paginator', 'data']) ||
            examinations !== this.props.store.getIn(['examinationsTreeFilter', 'selected'])
        )
            return;
        const response = await this.context.store.dispatch(request(
            '/registration/?' + queryString.stringify({
                student: students.map(student => student.get('id')).join(','),
                examination: examinations.keySeq().join(','),
                limit: 100000,
            }),
        ));
        const registrations = this.props.store.getIn(['paginator', 'data']).toMap().mapKeys((__, item) => item.get('id')).map(() => ({})).toJS();
        _.forEach(
            response.results,
            registration => 
            {
                if(registrations[registration.student.id]!==undefined)
                    return registrations[registration.student.id][registration.examination.id] = registration;
                return null;
            },
        );
        this.setState({registrations});
    }

    render() {
        return <PaginatedContainer
            store={this.props.store.get('paginator')}
            resource='student'
            style={this.style}
            readonly
            title={window.gettext('Registrations')}
            listFields={this.listFieldsSelector(this.props.store)}
            selectable
            filters={this.filtersSelector(this.props.store)}
            sorts={this.sorts}
            pageSize={this.props.pageSize}
            active={this.props.params.id}
            actions={this.props.actions}
            buttonActions={this.props.buttonActions}
        />;
    }
}
